module.exports = __webpack_public_path__ + "static/media/Douche.d7c58263.mp3";